import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { LoginGate } from '@/components/LoginGate';
import { AppShell } from '@/components/AppShell';
import { Home } from '@/views/Home';
import { Editor } from '@/views/Editor';
import { Resultado } from '@/views/Resultado';
import { FichaAtleta } from '@/views/FichaAtleta';
import { AtletaEnVivo } from '@/views/AtletaEnVivo';
import { Panel } from '@/views/Panel';
import { Speaker } from '@/views/Speaker';
import { FotosFinales } from '@/views/FotosFinales';
import { HerramientaHost } from '@/tools/HerramientaHost';
import { edicionActiva, EDICIONES } from '@/config/ediciones';

export function App() {
  return (
    <Routes>
      {/* Punto de entrada público: la raíz lleva a /resultados. */}
      <Route path="/" element={<Navigate to="/resultados" replace />} />
      {/* Página pública de resultados (sin AppShell admin). PROVISIONAL: ABIERTA
          al público (sin LoginGate). Entra de forma anónima (ensureAnonAuth) y
          el backend usa _authorize_public (events, campeonatos, event_detail).
          Para VOLVER a restringir a la whitelist: reactivar el <Route> con
          <LoginGate> comentado abajo (y borrar el abierto) + cambiar esos 3
          endpoints de functions/main.py de _authorize_public a _authorize. */}
      <Route path="/resultados" element={<AtletaEnVivo />} />
      {/* <Route path="/resultados" element={<LoginGate><AtletaEnVivo /></LoginGate>} /> */}
      {/* Birmingham 2026 (Cto. de Europa absoluto, European Athletics): misma
          vista pública que /resultados pero autocarga directa del Europeo
          (birmingham-2026?code=ECH26 vía eaLive, en el navegador) con portada
          propia. Reemplaza a la antigua /rieti (Europeo Sub-18, ya pasado). */}
      {/* 2026-08-11: /Birmingham redirige a /resultados mientras EA nos pide
          parar el tráfico a su API (la autocarga llamaba a EA en el navegador
          del visitante). Restaurar <AtletaEnVivo birmingham /> al reautorizar. */}
      <Route path="/Birmingham" element={<Navigate to="/resultados" replace />} />
      {/* Compat: la ruta vieja /atleta redirige a /resultados. */}
      <Route path="/atleta" element={<Navigate to="/resultados" replace />} />
      {/* Publicación en TELEGRAM del directo: la misma página de resultados
          pero SOLO con los campeonatos con publicación (sub-20 hoy; el
          Absoluto entra solo cuando la RFEA lo publique) y con el botón
          "Telegram" en cada serie. Detrás del login de Google + whitelist.
          Renombrada de /admin a /telegram al integrarla como herramienta del
          panel (2026-07-21); /admin queda como redirect de compat. */}
      <Route
        path="/telegram"
        element={
          <LoginGate>
            <AtletaEnVivo admin />
          </LoginGate>
        }
      />
      <Route path="/admin" element={<Navigate to="/telegram" replace />} />
      {/* Datos para el speaker (inscritos + dossier). Va FUERA del AppShell
          admin a propósito: usa la misma cabecera que /telegram (Mundo
          Atletismo) con vuelta al panel. Detrás del login + whitelist. */}
      <Route
        path="/speaker"
        element={
          <LoginGate>
            <Speaker />
          </LoginGate>
        }
      />
      {/* Recortes sin fondo para la tarjeta de FINAL de WhatsApp (v4).
          Detrás del login + whitelist, como /telegram y /speaker. */}
      <Route
        path="/fotos-finales"
        element={
          <LoginGate>
            <FotosFinales />
          </LoginGate>
        }
      />
      {/* Resto de la app: herramienta ADMIN, detrás de la whitelist. */}
      <Route path="/*" element={<AdminApp />} />
    </Routes>
  );
}

function AdminApp() {
  return (
    <LoginGate>
      <AppShell>
        <Routes>
          {/* La Home admin se movió a /inicio (la raíz ahora entra a /resultados). */}
          <Route path="/inicio" element={<Home />} />
          {/* Panel de equipo (ventana de atajos por campeonato). El panel de
              cada edición vive DIRECTO en /<id> (p. ej. /malaga, decisión
              2026-07-21); /panel y /panel/<id> quedan como redirects de
              compat. Ver src/config/ediciones.ts. */}
          <Route path="/panel" element={<Navigate to={`/${edicionActiva().id}`} replace />} />
          <Route path="/panel/:edicion" element={<PanelCompat />} />
          <Route path="/:edicion" element={<EdicionRoute />} />
          {/* Punto de montaje genérico de herramientas (patrón DLC): cualquier
              herramienta del registro con `cargar` se sirve aquí sin añadir más
              rutas. Ver src/tools/HerramientaHost.tsx. */}
          <Route path="/h/:herramientaId" element={<HerramientaHost />} />
          <Route path="/editor" element={<Editor />} />
          <Route path="/resultado" element={<Resultado />} />
          <Route path="/ficha-atleta" element={<FichaAtleta />} />
          <Route path="*" element={<Navigate to="/inicio" replace />} />
        </Routes>
      </AppShell>
    </LoginGate>
  );
}

/** /<edicion> (p. ej. /malaga): panel de esa edición si el slug existe en el
 *  catálogo; cualquier otra ruta desconocida sigue cayendo a /inicio. */
function EdicionRoute() {
  const { edicion } = useParams();
  if (!EDICIONES.some((e) => e.id === edicion)) return <Navigate to="/inicio" replace />;
  return <Panel />;
}

/** Compat: /panel/<id> → /<id> (URL antigua del panel). */
function PanelCompat() {
  const { edicion } = useParams();
  return <Navigate to={`/${edicion}`} replace />;
}
